import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet } from '../phieu-thong-tin-hang-ve-model-page/phieu-thong-tin-hang-ve.model';

const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class ThongTinHangVeService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	lastData$: BehaviorSubject<DeNghiNhapKho[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method--------------------------- */
	getListData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		;
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TTHV_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getListDataDetail(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TTHV_List_Detail', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getListDataHangVe(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/TTHV_List_HHKhoXuLy', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Get_Detail', item, { headers: httpHeaders });
	}
	getItemById(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Get_Item?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getHistory(itemId): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Get_History?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getId(Idct): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Get_IDMaster?Idct=${Idct}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getDataPBQA(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/QA_CCTC`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	downloadTemplate(itemId: any): string {
		return API_ROOT_URL + `/TTHV_DownFileDK?idFile=${itemId}`;
	}
	/*---------------------------------------------------------------------- */


	/*-------------------------------POST Method---------------------------- */
	add(item: DeNghiNhapKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Insert', item, { headers: httpHeaders });
	}
	addDetail(item:DeNghiNhapKhoChiTiet): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_Insert_Detail', item, { headers: httpHeaders });
	}
	
	update(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Duyet', item, { headers: httpHeaders });
	}
	updateWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Update_With_Detail', item, { headers: httpHeaders });
	}
	updateSLDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet[]>(API_ROOT_URL+'/TTHV_Update_SLThucGiao', item, { headers: httpHeaders });
	}
	
	checkCancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Check_Cancel?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Huy', item, { headers: httpHeaders });
	}
	cancelDetail(IdDetail: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Cancel_Detail?Id=${IdDetail}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/TTHV_Delete?IdDn=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */


	/*------------------------------ Qui trình ----------------------------- */
	XacNhanKiemTra(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKho>(API_ROOT_URL+'/TTHV_Confirm', item, { headers: httpHeaders });
	}
	KiemTraTungHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_XacNhanHang', item, { headers: httpHeaders });
	}
	PBKiemTraHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_PBXacNhanHang', item, { headers: httpHeaders });
	}
	TPXacNhanTungHang(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_TP_Confirm', item, { headers: httpHeaders });
	}
	GDXacNhanTungHang(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_GĐ_Confirm', item, { headers: httpHeaders });
	}
	PBXacNhanTungHang(item): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeNghiNhapKhoChiTiet>(API_ROOT_URL+'/TTHV_PBGiamSat_Confirm', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
}
